<div #container class="markdown-content">
  <markdown [data]="content" (ready)="enhanceRenderedContent()" />
</div>
